import React, {useEffect, useState} from "react";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {Button, Container, Form, Grid, Header, Segment} from "semantic-ui-react";
import ChangePassword, {ChangePasswordRequest} from "../../../services/password/change-password";
import ChangeUserPassword from "../../../services/password/change-password";
import RequestPasswordReset, {RequestPasswordResetRequest} from "../../../services/password/lost-password";
import {useBlockUI} from "../../../shared/services/block-ui-service";

const LostPasswordPage = () => {
    const [email, setEmail] = useState<Partial<RequestPasswordResetRequest>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const navigate = useNavigate();
    const blockUI = useBlockUI();
    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);


    const requestResetPassword = async () => {
        try {
            setLoading(true);
            if (email) {
                const result = await RequestPasswordReset(email);
                if (result.success) {
                    toast.success('Você irá receber as instruções para criar uma nova senha via e-mail.', {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                    await navigate('/');
                }
            }
        } finally {
            setLoading(false);
        }
    };

    return(
        <div suppressContentEditableWarning
             style={{backgroundImage: 'url(/login_bg.png)', backgroundSize: 'cover'}}>
            <Grid textAlign='center' style={{height: '100vh'}} verticalAlign='middle'>
                <Grid.Column style={{maxWidth: 450}}>
                    <img src={'/logotipo.png'} style={{
                        maxHeight: '5rem',
                        objectFit: 'contain',
                        marginTop: 10,
                        marginBottom: -20,
                        paddingBottom: 5,
                        alignSelf: 'center',
                        width: '100%',
                    }} alt={'fleetgame'}/>
            <Header as="h3" textAlign="center" color={'green'}>
                Recuperação de senha
            </Header>
            <Form onSubmit={requestResetPassword}>
                <Segment>
                    <Form.Field>
                        <Form.Input
                            fluid
                            placeholder="Insira o e-mail da conta"
                            name="email"
                            value={email?.email}
                            type='email'
                            onChange={(event) => setEmail({...email, email: event.target.value})}
                            required
                        />
                    </Form.Field>
                    <Button fluid size='large' color={'green'}>
                        Enviar
                    </Button>
                </Segment>
            </Form>
                </Grid.Column>
                </Grid>
            </div>
    );

}

export default LostPasswordPage;